import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import sortBy from 'lodash.sortby';
import { Link } from 'react-router-dom';
import { useUserStore } from '../../../components/userStore';

const CredentialedCBOs = () => {
	const { user } = useUserStore();
	const credAgencies = useQuery({
		queryKey: ['credentialed-agencies', user.coord_agency.id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/credentialed-agencies`,
			);
			return sortBy(data, [
				({ executing_coord_agency }) => executing_coord_agency.agency_name,
			]);
		},
	});
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>
						<Link to="/admin-panel" className="link">
							Admin Panel
						</Link>
					</li>
					<li>Credentialed Billing Service Providers (CBOs)</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<div className="flex flex-row items-end">
					<h2 className="grow">Credentialed Billing CBOs</h2>
					<Link className="btn btn-primary" to="/admin-panel/cred-cbos/add">
						Add CBO
					</Link>
				</div>
				<div className="divider" />
				<table className="table table-zebra table-lg">
					<tbody>
						{credAgencies.isLoading && (
							<tr>
								<td>
									<span className="loading loading-spinner loading-xs" />
								</td>
							</tr>
						)}
						{credAgencies.isFetched && credAgencies.data.length === 0 && (
							<tr>
								<td>No Credentialed CBOs found</td>
							</tr>
						)}
						{credAgencies.isFetched &&
							credAgencies.data.length > 0 &&
							credAgencies.data.map((agency) => (
								<tr
									key={`${agency.healthplan_coord_agency_id}-${agency.executing_coord_agency_id}`}
								>
									<td>{agency.executing_coord_agency.agency_name}</td>
									<td>
										<Link
											to={`/admin-panel/cred-cbos/modify/${agency.id}`}
											className="btn btn-primary btn-sm"
										>
											Modify
										</Link>
									</td>
								</tr>
							))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default CredentialedCBOs;
